<template>
  <el-upload
    :drag="draggable"
    action=""
    :class="{ 'avatar-uploader': type === 'image' }"
    :type="type"
    :accepts="accepts"
    :size="size"
    :limit="limit"
    :multiple="multiple"
    :http-request="uploadAction"
    :on-success="successVideo"
    :on-exceed="handleExceed"
    :on-remove="deleteAttachment"
    :file-list="attachmentList"
    :show-file-list="type === 'attachment'"
    ref="upload"
    :disabled="disabled"
  >
    <template v-if="type === 'image'">
      <i class="el-icon-plus avatar-uploader-icon"></i>
      <label class="upload-text">上传图片</label>
    </template>
    <template v-else>
      <i class="el-icon-upload"></i>
      <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
      <div v-if="type === 'attachment'" class="el-upload__tip" slot="tip">
        只能上传{{ formatAccepct }}文件，且不超过{{ size }}Mb
      </div>
      <!-- <div v-if="type === 'video'" class="el-upload__tip" slot="tip">
        只能上传{{ formatAccepct }}文件，且不超过1Gb
      </div> -->
    </template>
  </el-upload>
</template>

<script>
import FileHandler, { isMp3 } from "@/utils/file";
import { setItem } from "@/utils/storage.js";
export default {
  props: {
    /*上传文件类型, 'attachment'/'video'/'audio'/'image', 默认attachment */
    type: {
      type: String,
      default: "attachment",
    },
    /*上传文件格式,仅在type=attachment时有效,支持的格式为word/excel/ppt/pdf/jpg/png/txt中的一种或多种,默认都支持 */
    accepts: {
      // eslint-disable-next-line vue/require-prop-type-constructor
      type: Array,
      default: () => {
        return ["word", "excel", "ppt", "pdf", "jpg", "jpeg", "png", "txt"];
      },
    },
    /*上传文件大小,仅在type=attachment时有效,默认20Mb */
    size: {
      type: Number,
      default: 20,
    },
    /*文件数量限制*/
    limit: {
      type: Number,
      default: 1,
    },
    /*是否可以多选,默认支持*/
    multiple: {
      type: Boolean,
      default: true,
    },
    /*是否禁用上传功能*/
    disabled: {
      type: Boolean,
      default: false,
    },
    /*上传到oss上的路径*/
    path: {
      type: String,
      default: "",
    },
    /*附件列表*/
    attachmentList: {
      type: Array,
      default: () => {
        return [];
      },
    },
    draggable: {
      type: Boolean,
      default: true,
    },
  },
  model: {
    prop: "attachmentList",
    event: "returnBack",
  },
  computed: {
    formatAccepct() {
      return typeof this.accepts === "string"
        ? this.accepts
        : this.accepts.join("/");
    },
  },
  methods: {
    deleteAttachment(file) {
      // 从已上传文件列表里找出url相同的文件删除并跳出循环减少耗时操作
      for (let i = 0; i < this.attachmentList.length; i++) {
        if (file.url == this.attachmentList[i].url) {
          this.attachmentList.splice(i, 1);
          break;
        }
      }
    },
    handleExceed() {
      // 选择文件数量超出限制给出提示
      this.$message.warning(`至多上传${this.limit}个文件`);
    },
    successVideo(response, file, fileList) {
      const splitList = file.name.split(".");
      if (splitList[splitList.length - 1] == "mp4") {
        var url = URL.createObjectURL(fileList[0].raw);
        var audioElement = new Audio(url);
        //扩展 onloadedmetadata 视频加载完执行，onload图片加载完执行
        audioElement.onloadedmetadata = () => {
          this.duration = parseInt(audioElement.duration); //时长为秒，取整
          // setItem("duration", this.duration);
          this.$emit("getVideoCreditEvent", this.duration);
        };
      }
    },
    async uploadAction(e) {
      let file = e.file;
      if (this.type === "attachment") {
        // 文件上传之前校验文件是否符合格式要求,符合继续上传，不符合终止上传
        if (file.size > this.size * 1024 * 1024) {
          this.$message.warning(
            `附件大小不能超过${this.size}Mb,请重新选择文件`
          );
          this.$refs.upload.uploadFiles.pop();
          return;
        }
        // 双层校验上传的图片格式
        let FileExt = file.name.replace(/.+\./, "");
        const wordExts = ["doc", "docx"];
        const excelExts = ["xls", "xlsx"];
        const allowWord =
          wordExts.includes(FileExt) && this.accepts.includes("word");
        const allowExcel =
          excelExts.includes(FileExt) && this.accepts.includes("excel");
        const pptExts = ["ppt", "pptx"];
        const allowPpt =
          pptExts.includes(FileExt) && this.accepts.includes("ppt");
        if (
          this.accepts.indexOf(FileExt.toLowerCase()) === -1 &&
          !allowWord &&
          !allowExcel &&
          !allowPpt
        ) {
          this.$refs.upload.uploadFiles.pop();
          this.$message.warning("附件格式不符合要求,请重新选择文件");
          return;
        }
        let isAttachment = await FileHandler.isAttachment(file, this.accepts);
        if (!isAttachment) {
          this.$refs.upload.uploadFiles.pop();
          this.$message.warning("附件格式不符合要求,请重新选择文件");
          return;
        }
      } else if (this.type === "video") {
        const isVideo = await FileHandler.isVideo(file);
        if (!isVideo) {
          this.$message({
            message:
              // "请上传格式为mp4或webm格式的视频文件，其余文件格式无法上传哦！",
              "请上传格式为mp4格式的视频文件，其余文件格式无法上传哦！",
            type: "warning",
          });
          // 重点: 异常流程时必须要清除上传的文件，否则设置限制文件上传数量为1时不能再次执行上传事件
          this.$refs.upload.uploadFiles.pop();
          return;
        }
        if (file.size / (1024 * 1024 * 1024) > 1) {
          this.$message.warning("附件大小不能超过1Gb,请重新选择文件");
          // 重点: 异常流程时必须要清除上传的文件，否则设置限制文件上传数量为1时不能再次执行上传事件
          this.$refs.upload.uploadFiles.pop();
          return;
        }
        // console.log(file.size / (1024 * 1024 * 1024));
      } else if (this.type === "image") {
        // 文件上传之前校验文件是否符合格式要求,符合继续上传，不符合终止上传
        if (file.size > this.size * 1024 * 1024) {
          this.$message.warning(
            `附件大小不能超过${this.size}Mb,请重新选择文件`
          );
          this.$refs.upload.uploadFiles.pop();
          return;
        }
        const isImage = await FileHandler.isImage(file);
        if (!isImage) {
          this.$message({
            message: "请上传格式为png、jpg格式的文件，其余文件格式无法上传哦！",
            type: "warning",
          });
          // 重点: 异常流程时必须要清除上传的文件，否则设置限制文件上传数量为1时不能再次执行上传事件
          this.$refs.upload.uploadFiles.pop();
          return;
        }
      } else if (this.type === "audio") {
        const isAudeo = isMp3(file);
        if (!isAudeo) {
          this.$message({
            message: "请上传格式为mp3格式的音频文件，其余文件格式无法上传哦！",
            type: "warning",
          });
          // 重点: 异常流程时必须要清除上传的文件，否则设置限制文件上传数量为1时不能再次执行上传事件
          this.$refs.upload.uploadFiles.pop();
          return;
        }
      }
      //格式检验通过,执行上传任务(params: 文件上传到oss的路径, 上传的文件, 上传进度和断点标记回调)
      FileHandler.uploadFile(this.path, file, (p) => {
        let progress = Math.round(p * 100);
        this.$emit("progress", progress);
      }).then((res) => {
        const { res: result } = res;
        const obj = {
          url: result.requestUrls[0].split("?")[0],
          name: file.name,
          path: res.name,
          size: (file.size / 1024 / 1024).toFixed(2),
        };
        this.attachmentList.push(obj);
        this.$emit("returnBack", this.attachmentList);
      }).catch(_ => {
        this.$message.error("上传失败");
        this.$refs.upload.uploadFiles.pop();
      });
    },
  },
};
</script>

<style lang="scss" scoped>
$textColor: #51627d;
.avatar-uploader /deep/ .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  background-color: #f7f9fc;
  width: 104px;
  height: 104px;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 84px;
  height: 84px;
  line-height: 84px;
  text-align: center;
}
.upload-text {
  position: absolute;
  bottom: 10px;
  left: 50%;
  transform: translateX(-50%);
  color: $textColor;
  font-size: 13px;
}
</style>
